import { useAtomValue } from 'jotai'
import { accountsAtom } from '@/src/stores/accounts/atoms'

/**
 * Returns whether the user has any active accounts (excluding ignored ones).
 * Useful for determining if portfolio/wallet UI should be shown.
 */
export function useHasAccounts() {
  const accounts = useAtomValue(accountsAtom)
  return (
    accounts.filter((account) => account.account_status !== 'ignored').length >
    0
  )
}
